import React from 'react';

// Tailwind class strings shared by the /developers topics. Colours follow
// docs/design/developers-redesign-mockup.html (tailwind gray-* / blue-*).
export const button =
  'inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-900 hover:border-blue-500 hover:text-blue-600';
export const primaryButton =
  'inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-blue-600 bg-blue-600 px-3 py-1.5 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-wait disabled:opacity-60';
export const card =
  'relative block rounded-lg border border-gray-200 bg-white px-3.5 py-3 shadow-sm hover:border-blue-500';
export const inlineCode = 'rounded bg-gray-100 px-1 text-[0.85em]';
export const pageTitle = 'text-2xl font-bold tracking-tight text-gray-900';

// The 让 AI 自己装 / 自己动手 switch, shared by the client pages and Worklog skills.
export type InstallMode = 'ai' | 'manual';

export const ModeSwitch: React.FC<{ mode: InstallMode; onChange: (mode: InstallMode) => void }> = ({
  mode,
  onChange,
}) => (
  <div className="inline-flex gap-0.5 rounded-lg bg-gray-100 p-0.5">
    {(['ai', 'manual'] as const).map((m) => (
      <button
        key={m}
        type="button"
        onClick={() => onChange(m)}
        className={`rounded-md px-3 py-1 text-xs ${mode === m ? 'bg-white font-semibold text-gray-900 shadow-sm' : 'text-gray-500'}`}
      >
        {m === 'ai' ? '让 AI 自己装' : '自己动手'}
      </button>
    ))}
  </div>
);

// Numbered step heading on the client pages.
export const StepHeading: React.FC<{ n: number; title: string }> = ({ n, title }) => (
  <h2 className="mb-2.5 mt-7 flex items-center gap-2 text-base font-semibold text-gray-900">
    <span className="grid h-5 w-5 flex-none place-items-center rounded-full bg-blue-600 text-[11px] font-bold text-white">
      {n}
    </span>
    {title}
  </h2>
);
